var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 59,
    viewBox: "0 0 204 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.396 59H7.55371C3.40106 59 0 55.6794 0 51.625V7.375C0 3.3206 3.40106 1.7097e-06 7.55371 1.7097e-06H196.396C200.549 1.7097e-06 203.95 3.3206 203.95 7.375V51.625C203.95 55.6794 200.549 59 196.396 59Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M196.396 1.18184C199.894 1.18184 202.74 3.96038 202.74 7.375V51.625C202.74 55.0396 199.894 57.8182 196.396 57.8182H7.55371C4.05634 57.8182 1.21048 55.0396 1.21048 51.625V7.375C1.21048 3.96038 4.05634 1.18184 7.55371 1.18184H196.396ZM196.396 1.7097e-06H7.55371C3.40106 1.7097e-06 0 3.3206 0 7.375V51.625C0 55.6794 3.40106 59 7.55371 59H196.396C200.549 59 203.95 55.6794 203.95 51.625V7.375C203.95 3.3206 200.549 1.7097e-06 196.396 1.7097e-06Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6353 15.1096C71.6353 16.3413 71.2576 17.3277 70.5136 18.0633C69.6581 18.9354 68.5439 19.3742 67.1786 19.3742C65.8737 19.3742 64.7595 18.928 63.8455 18.0486C62.9297 17.1562 62.4727 16.061 62.4727 14.7501C62.4727 13.4392 62.9297 12.344 63.8455 11.459C64.7595 10.5722 65.8737 10.126 67.1786 10.126C67.8282 10.126 68.4476 10.2569 69.0387 10.5003C69.6279 10.7455 70.1076 11.0774 70.455 11.4867L69.6657 12.2647C69.0595 11.5659 68.2342 11.2212 67.1786 11.2212C66.2268 11.2212 65.4016 11.5457 64.701 12.2002C64.0079 12.8566 63.6605 13.7065 63.6605 14.7501C63.6605 15.7937 64.0079 16.651 64.701 17.3074C65.4016 17.9545 66.2268 18.2864 67.1786 18.2864C68.1889 18.2864 69.0387 17.9545 69.7091 17.3C70.151 16.8667 70.4022 16.2694 70.4683 15.506H67.1786V14.4404H71.5673C71.6202 14.6708 71.6353 14.8939 71.6353 15.1096V15.1096Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5981 11.4146H74.4756V14.2171H78.1921V15.2828H74.4756V18.0853H78.5981V19.1712H73.3086V10.3286H78.5981V11.4146Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5121 19.1712H82.345V11.4146H79.8164V10.3286H86.0425V11.4146H83.5121V19.1712V19.1712Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5479 19.1712V10.3286H91.713V19.1712H90.5479Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8783 19.1712H95.7207V11.4146H93.1826V10.3286H99.4163V11.4146H96.8783V19.1712Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111.204 18.0338C110.311 18.928 109.204 19.3742 107.884 19.3742C106.557 19.3742 105.45 18.928 104.557 18.0338C103.665 17.1414 103.222 16.0463 103.222 14.7501C103.222 13.4539 103.665 12.3588 104.557 11.4664C105.45 10.5722 106.557 10.126 107.884 10.126C109.197 10.126 110.303 10.5722 111.197 11.4738C112.095 12.3735 112.539 13.4613 112.539 14.7501C112.539 16.0463 112.095 17.1414 111.204 18.0338ZM105.42 17.2926C106.092 17.9545 106.91 18.2864 107.884 18.2864C108.851 18.2864 109.676 17.9545 110.341 17.2926C111.011 16.6307 111.351 15.7808 111.351 14.7501C111.351 13.7194 111.011 12.8695 110.341 12.2076C109.676 11.5457 108.851 11.2138 107.884 11.2138C106.91 11.2138 106.092 11.5457 105.42 12.2076C104.749 12.8695 104.41 13.7194 104.41 14.7501C104.41 15.7808 104.749 16.6307 105.42 17.2926V17.2926Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.176 19.1712V10.3286H115.592L119.996 17.2058H120.047L119.996 15.5059V10.3286H121.161V19.1712H119.945L115.333 11.9548H115.282L115.333 13.6621V19.1712H114.176V19.1712Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.934 32.0848C99.3861 32.0848 96.4874 34.7214 96.4874 38.3591C96.4874 41.9673 99.3861 44.6315 102.934 44.6315C106.49 44.6315 109.389 41.9673 109.389 38.3591C109.389 34.7214 106.49 32.0848 102.934 32.0848ZM102.934 42.1609C100.988 42.1609 99.3125 40.5919 99.3125 38.3591C99.3125 36.0968 100.988 34.5554 102.934 34.5554C104.881 34.5554 106.564 36.0968 106.564 38.3591C106.564 40.5919 104.881 42.1609 102.934 42.1609V42.1609ZM88.8676 32.0848C85.3117 32.0848 82.4205 34.7214 82.4205 38.3591C82.4205 41.9673 85.3117 44.6315 88.8676 44.6315C92.4216 44.6315 95.3147 41.9673 95.3147 38.3591C95.3147 34.7214 92.4216 32.0848 88.8676 32.0848ZM88.8676 42.1609C86.9187 42.1609 85.2381 40.5919 85.2381 38.3591C85.2381 36.0968 86.9187 34.5554 88.8676 34.5554C90.8146 34.5554 92.4896 36.0968 92.4896 38.3591C92.4896 40.5919 90.8146 42.1609 88.8676 42.1609ZM72.1286 34.0078V36.6739H78.6493C78.4586 38.1636 77.9487 39.2588 77.1669 40.0221C76.2152 40.944 74.7327 41.9673 72.1286 41.9673C68.1157 41.9673 64.9734 38.8053 64.9734 34.8873C64.9734 30.9693 68.1157 27.8073 72.1286 27.8073C74.2984 27.8073 75.8771 28.6351 77.0423 29.7082L78.9666 27.8294C77.3369 26.3102 75.169 25.1431 72.1286 25.1431C66.6257 25.1431 62.001 29.5146 62.001 34.8873C62.001 40.26 66.6257 44.6315 72.1286 44.6315C75.1029 44.6315 77.3369 43.6801 79.0931 41.8954C80.8928 40.1383 81.4536 37.6677 81.4536 35.6727C81.4536 35.0532 81.4008 34.4835 81.3064 34.0078H72.1286ZM140.576 36.0747C140.046 34.6716 138.409 32.0848 135.074 32.0848C131.769 32.0848 129.017 34.6273 129.017 38.3591C129.017 41.8733 131.741 44.6315 135.391 44.6315C138.342 44.6315 140.046 42.8744 140.746 41.8511L138.556 40.4259C137.825 41.4695 136.83 42.1609 135.391 42.1609C133.961 42.1609 132.936 41.5211 132.279 40.26L140.873 36.7882L140.576 36.0747V36.0747ZM131.814 38.1636C131.741 35.7446 133.738 34.5056 135.17 34.5056C136.292 34.5056 137.243 35.0532 137.561 35.8368L131.814 38.1636V38.1636ZM124.829 44.2498H127.654V25.8124H124.829V44.2498ZM120.202 33.4824H120.108C119.473 32.7485 118.263 32.0848 116.729 32.0848C113.512 32.0848 110.569 34.843 110.569 38.3794C110.569 41.8954 113.512 44.6315 116.729 44.6315C118.263 44.6315 119.473 43.9622 120.108 43.2063H120.202V44.106C120.202 46.5048 118.89 47.7935 116.773 47.7935C115.047 47.7935 113.976 46.5767 113.534 45.5534L111.077 46.5545C111.786 48.2176 113.661 50.2642 116.773 50.2642C120.085 50.2642 122.88 48.3614 122.88 43.7318V32.4664H120.202V33.4824V33.4824ZM116.971 42.1609C115.024 42.1609 113.394 40.5697 113.394 38.3794C113.394 36.1687 115.024 34.5554 116.971 34.5554C118.89 34.5554 120.402 36.1687 120.402 38.3794C120.402 40.5697 118.89 42.1609 116.971 42.1609V42.1609ZM153.803 25.8124H147.046V44.2498H149.864V37.2639H153.803C156.932 37.2639 160.001 35.0532 160.001 31.5372C160.001 28.023 156.925 25.8124 153.803 25.8124V25.8124ZM153.877 34.6992H149.864V28.377H153.877C155.98 28.377 157.181 30.0825 157.181 31.5372C157.181 32.9643 155.98 34.6992 153.877 34.6992ZM171.294 32.0498C169.258 32.0498 167.141 32.9274 166.27 34.8725L168.771 35.8958C169.309 34.8725 170.298 34.5407 171.345 34.5407C172.806 34.5407 174.289 35.398 174.311 36.9117V37.1053C173.801 36.8177 172.71 36.3918 171.367 36.3918C168.674 36.3918 165.93 37.8391 165.93 40.5402C165.93 43.0109 168.136 44.602 170.616 44.602C172.512 44.602 173.558 43.7668 174.215 42.7951H174.311V44.2203H177.033V37.1477C177.033 33.8788 174.532 32.0498 171.294 32.0498ZM170.954 42.1535C170.032 42.1535 168.748 41.7073 168.748 40.5919C168.748 39.1648 170.349 38.6172 171.736 38.6172C172.976 38.6172 173.558 38.8845 174.311 39.2367C174.09 40.944 172.585 42.1535 170.954 42.1535V42.1535ZM186.947 32.4535L183.708 40.4462H183.612L180.264 32.4535H177.225L182.256 43.623L179.386 49.8383H182.33L190.082 32.4535H186.947V32.4535ZM161.549 44.2498H164.374V25.8124H161.549V44.2498Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7651 11.1197C15.3213 11.5732 15.0645 12.2794 15.0645 13.1939V45.8135C15.0645 46.728 15.3213 47.4342 15.7651 47.8877L15.8746 47.9873L34.5964 29.7157V29.2843L15.8746 11.0127L15.7651 11.1197Z",
    fill: "url(#paint0_linear_6688_132765)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8294 35.8091L34.5957 29.7155V29.2841L40.837 23.1905L40.9767 23.2697L48.368 27.3758C50.4774 28.541 50.4774 30.4585 48.368 31.6311L40.9767 35.7298L40.8294 35.8091V35.8091Z",
    fill: "url(#paint1_linear_6688_132765)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.977 35.7299L34.596 29.4999L15.7646 47.8876C16.4653 48.6067 17.6078 48.6933 18.907 47.9742L40.977 35.7299",
    fill: "url(#paint2_linear_6688_132765)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.977 23.27L18.907 11.0256C17.6078 10.3139 16.4653 10.4006 15.7646 11.1197L34.596 29.5L40.977 23.27Z",
    fill: "url(#paint3_linear_6688_132765)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6688_132765",
    x1: 32.9342,
    y1: 46.1532,
    x2: 8.18722,
    y2: 20.8066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6688_132765",
    x1: 51.1147,
    y1: 29.4977,
    x2: 14.5595,
    y2: 29.4977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6688_132765",
    x1: 37.5072,
    y1: 26.1131,
    x2: 3.94836,
    y2: -8.25892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6688_132765",
    x1: 11.0244,
    y1: 58.7401,
    x2: 26.0099,
    y2: 43.3916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.5dca297c04b8bb20d591d935d005514e.svg";
export { ForwardRef as ReactComponent };